export default __webpack_public_path__ + "static/media/Sistering_Logo.74849825.svg";